'use strict'

angular
  .module('basalteApp')
  .constant('BAS_OPEN_CLOSE_DEVICES', {
    EVT_OPEN_CLOSE_DEVICES_UPDATED: 'evtBasOpenCloseDevicesUpdated'
  })
